import React from 'react'

const CRMIntroduction = () => {
  return (
    <>
        <section id="first" className="about bg2">
  <div className="container">
    <div className="section-title">
      <br />
      <h2 className="animated fadeInDown">Introduction</h2>
      <div className="bar" />
      <div className="row">
        <div className="col-lg-12">
          <div className=" cd-intro-content bouncy shadow p-4 animated swing">
            <div className="row">
              <div className="col-md-12">
                <h3 className="text-left mesee-mg animated fadeInUp ease-out-circ d2 a-1 f2 fw3 heading">
                  CRM-Fixfella
                </h3>
                <p className="text-justify ">
                  Customer will generate the complaint with the help of mobile
                  application or via call (IVR calling system - Need to
                  implement via API. API will be provided by client). Once the
                  complaint is raised then it will go to NSC. Now NSC will
                  assign the registered call to the Dealer. Once the call is
                  assigned to the dealer, they can accept or reject the call.
                  Once the call is rejected with the remark then again it will
                  go to the NSC. Once the call is accepted by the dealer, he
                  will assign the Technician and then technician will visit at
                  the place. If the complaint which is raised by the customer is
                  resolved then technician will close the complaint but that
                  will be soft close.The calls which are closed by the dealer or
                  technician will always be soft close. If the company is not
                  resolved then the complaint status will be pending with the
                  remark. if any approval is needed then technician will share
                  the details to dealer for the approval. The approval process
                  will work as below: Dealer can approve if he can, otherwise,
                  he will send to the ASH for the further approval, after that
                  ASH will send to NSH for further approval. In the approval
                  management user can see the list who have approved the
                  particular details. once the call will be closed then it will
                  automatically move to the closer call details. In the starting
                  when the register then it will be in the register call status,
                  once the call status is changed to pending or open then it
                  will move to the pending call.
                </p>
                <p className="text-justify" />
              </div>
              {/* <div className="col-md-4">
                <div className="video-responsive mt-5">
                  <video width="100%" height={200} controls="">
                    <source
                      src="assets/img/all-banner/Alobah-Final.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default CRMIntroduction